import React from 'react';
import { Controller } from 'react-hook-form';
import FormGroup from './FormGroup';
import Checkbox from './Checkbox';

export interface FormCheckBoxListItem {
  value: string;
  text: string;
}

export interface FormCheckBoxListProps {
  name?: string;
  label?: string;
  error?: unknown;
  errorMessage?: string;
  items?: FormCheckBoxListItem[];
  required?: boolean;
  getValues: (name: string) => string[] | undefined;
  setValue: (name: string, value: string[]) => void;
  control?: any;
}

const FormCheckBoxList = ({
  name,
  label,
  error,
  errorMessage,
  items = [],
  required,
  getValues,
  setValue,
  control,
}: FormCheckBoxListProps) => {
  const handleOnChange = (item: FormCheckBoxListItem) => {
    if (name == null) return;
    const value = getValues(name) ?? [];
    const arr = value.includes(item.value)
      ? value.filter((i) => i !== item.value)
      : [...value, item.value];
    setValue(name, arr);
  };
  return (
    <FormGroup
      label={label}
      required={required}
      error={Boolean(error)}
      errorMessage={errorMessage}
    >
      <Controller
        name={name ?? ''}
        control={control}
        defaultValue={[]}
        render={() => (
          <>
          {items.map((x) => (
            <div
              className="mb-2"
              key={x.value}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              <Checkbox
                onChange={() => handleOnChange(x)}
                checked={name ? (getValues(name)?.includes(x.value) ?? false) : false}
                label={x.text}
              />
            </div>
          ))}
          </>
        )}
      />
    </FormGroup>
  );
};
export default FormCheckBoxList;
